import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { getCategoryByHisType } from '@/pages/Onboarding/Layouts/OwnAIMan_Trans_L/utils/getCategoryByHisType';
import { HIS_VOICE_OPTIONS } from '@/pages/Onboarding/options/HisVoice/HIS_VOICE_OPTIONS';
import { getHisVoiceTitleById } from '@/pages/Onboarding/options/HisVoice/utils/getHisVoice';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const HisVoiceScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'HisVoice',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const hisVoice = form.watch('his_voice');

  const hisType = form.watch('his_type');

  const handleSelect = (option: OnbOptionType<LayoutDataType['his_voice']>) => {
    form.setValue('his_voice', option.id);
  };

  const handleNextStep = () => {
    const hisVoiceTitle = getHisVoiceTitleById(hisVoice);

    userService.createOrUpdate({
      categories: getCategoryByHisType(hisType || 'twink'),
      onboarding_data: {
        his_voice: hisVoiceTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>How Does He Sound?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {HIS_VOICE_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={hisVoice === option.id}
              control={form.control}
              option={option}
              name="his_voice"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!hisVoice}
      />
    </OnboardingPage>
  );
};
